/**
 * @ngdoc Controller
 * @name InstallationSettingsController
 */
(function() {
    'use strict';

    angular.module('vrm.core')
        .controller('InstallationShareController', InstallationShareController);

    /**
     * @constructor
     * @ngInject
     */
    function InstallationShareController(localStorageService, $q,$scope,$log, $stateParams, ApiService, vrmNotificationsService, vrmNotificationType, locale, $state, vrmUserAccessLevel, InstallationsService, UserService) {
        $log.info('InstallationShareController');

        $scope.password = null;
        $scope.loading = true;


        function login(response) {
            // Login user
            response = response[0];
            vrmNotificationsService.add( {type: vrmNotificationType.SUCCESS, message: locale.getString('share.share_success') });
            localStorageService.set("token", response.data.token);
            $scope.$emit('login');
            $state.go('base.installation.dashboard', {id: $stateParams.id});
        }
        function error(response)
        {
            $scope.loading = false;
            if (response != "password_required")
            {
                $state.go('base.installation-overview');
            }
        }

        function verifyShare() {
            var data = {
                token: $stateParams.token,
                idSite: $stateParams.id
            };
            if ($scope.password)
            {
                data.password = $scope.password;
            }

            function runVerification() {

                $q.all([
                    ApiService.verifyShare(data),
                    locale.ready('share')
                ]).then(login, error);
            }
            // If we are logged in and admin or restricted admin or have the current site in our set, open it directly
            if (ApiService.isLoggedIn())
            {
                UserService.getUser().then(function() {
                    if (UserService.user && ( UserService.user.accessLevel === vrmUserAccessLevel.ADMIN || UserService.user.accessLevel === vrmUserAccessLevel.RESTRICTED_ADMIN))
                    {
                        $state.go('base.installation.dashboard', {id: $stateParams.id});
                    }
                    else if (InstallationsService.installations && InstallationsService.installations.length > 0)
                    {
                        var found = false;
                        _.each(InstallationsService.installations, function(installation) {
                            if (installation.idSite == $stateParams.id)
                            {
                                $state.go('base.installation.dashboard', {id: $stateParams.id});
                                found = true;
                            }
                        });

                        if (!found)
                            runVerification();
                    }
                    else
                    {
                        runVerification();
                    }
                }, runVerification);
            }
            else
            {
                runVerification();
            }
        }


        $scope.verifyShare = function()
        {
            verifyShare();
        };

        verifyShare();
    }

})();
